import { useState } from "react";
import { SearchAndFilters } from "../../SearchAndFilters";

interface DocumentsToolbarProps {
  searchText: string;
  onSearchChange: (text: string) => void;
  statusFilter: "Published" | "Unpublished" | "All";
  onStatusFilterChange: (status: "Published" | "Unpublished" | "All") => void;
  categoryFilters: number[];
  onCategoryFiltersChange: (categoryIds: number[]) => void;
  onReset: () => void;
}

const ALL_CATEGORIES = [
  { id: 1, name: "Manual" },
  { id: 2, name: "Procedure" },
  { id: 3, name: "Health & Safety" },
  { id: 4, name: "Drawings" },
  { id: 5, name: "Qualifications" },
  { id: 6, name: "Mechanical" },
  { id: 7, name: "Electrical" },
  { id: 8, name: "Hydraulic" },
  { id: 9, name: "Structural" },
  { id: 10, name: "Instrumentation" },
  { id: 11, name: "Lubrication" },
  { id: 12, name: "Other" },
  { id: 13, name: "Safety" },
  { id: 14, name: "Maintenance" },
  { id: 15, name: "Operations" },
  { id: 16, name: "Reliability" },
];

export function DocumentsToolbar({
  searchText,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  categoryFilters,
  onCategoryFiltersChange,
  onReset,
}: DocumentsToolbarProps) {
  const [searchDraft, setSearchDraft] = useState(searchText);

  return (
    <SearchAndFilters
      activeFilterCount={
        categoryFilters.length + (statusFilter === "All" ? 0 : 1)
      }
      facets={[
        {
          key: "category",
          label: "Category",
          options: ALL_CATEGORIES.map((category) => ({
            label: category.name,
            value: String(category.id),
          })),
          value: categoryFilters.map(String),
          onChange: (values) => onCategoryFiltersChange(values.map(Number)),
        },
        {
          key: "status",
          label: "Status",
          options: [
            { label: "Published", value: "Published" },
            { label: "Unpublished", value: "Unpublished" },
          ],
          value: statusFilter === "All" ? [] : [statusFilter],
          selectionMode: "single",
          onChange: (values) =>
            onStatusFilterChange(
              (values[0] as "Published" | "Unpublished" | undefined) ?? "All",
            ),
        },
      ]}
      filterAriaLabel="Document filters"
      onReset={() => {
        setSearchDraft("");
        onSearchChange("");
        onReset();
      }}
      onSearch={onSearchChange}
      onSearchChange={setSearchDraft}
      searchPlaceholder="Search documents"
      searchValue={searchDraft}
    />
  );
}
